
const functionsList = {
  docOrgFunction: (args) => {
    args[1] = args[1]? args[1].split('-').reverse().join('.'): ''

    return `${args[0]}${args[1]? (', '+args[1]): ''}`
  }
}

export default functionsList
